import CrudTable from './CrudTable';
import { endpoints } from '../../services/api';

const Clientes = () => {
  return (
    <CrudTable
      title="Clientes"
      apiEndpoint={endpoints.oficina.clientes}
      columns={[
        { key: 'nombre', label: 'Nombre' },
        { key: 'direccion', label: 'Dirección' },
        { key: 'agente', label: 'Agente' }
      ]}
      formFields={[
        { name: 'nombre', label: 'Nombre', required: true },
        { name: 'direccion', label: 'Dirección', type: 'textarea' },
        { name: 'agente', label: 'Agente' }
      ]}
    />
  );
};

export default Clientes;

